/**
 * Removes content inside array brackets from a path string.
 *
 * @param {string} path - The path string containing array content to remove.
 * @returns {string} The path with array content removed.
 *
 * @example
 * removeArrayContent('actions[id:70q6lorxah1e].name') // Returns 'actions[].name'
 * removeArrayContent('users[0].profile.name') // Returns 'users[].profile.name'
 */
export const removeArrayContent = (path) => {
  if (typeof path !== 'string') {
    return path;
  }

  return path.replace(/\[([^\]]+)\]/g, '[]');
};
